const LocationIndex = () => import('./_page/location.vue')
const ExpertiseIndex = () => import('./_page/expertise.vue')
const PackagesIndex = () => import('./_page/packages.vue')
const ExpiryIndex = () => import('./_page/expiry.vue')
const InactiveIndex = () => import('./_page/inactive.vue')
const SubscriptionIndex = () => import('./_page/subscription.vue')
const JobIndex = () => import('./_page/job.vue')
const SuccessIndex = () => import('./_page/subscribed-success.vue')
const PhoneSuccessIndex = () => import('./_page/phone-success.vue')

import { ExpertGuard, BidGuard, CheckExpertGuard, CheckAuth } from '@/common/guard'
export default [
    {
        path: '/location/update/:status',
        beforeEnter: CheckAuth,
        component: LocationIndex,
        name: 'LocationUpdatePage'
    },
    {
        path: '/expertise/update/:status',
        beforeEnter: CheckAuth,
        component: ExpertiseIndex,
        name: 'ExpertiseUpdatePage'
    },
    {
        path: '/bid/job/:id',
        beforeEnter: BidGuard, 
        /*beforeEnter: ExpertGuard,*/
        component: JobIndex,
        name: 'JobBiddingPage'
    },
    {
        path: '/packages',
        beforeEnter: CheckExpertGuard,
        component: PackagesIndex,
        name: 'PackagesIndex'
    },
    {
        path: '/expiry',
        component: ExpiryIndex,
        name: 'ExpiryIndex'
    },
    {
        path: '/inactive',
        component: InactiveIndex,
        name: 'InactiveIndex'
    },
    {
        path: '/packages/subscribe/:id/:option',
        beforeEnter: CheckExpertGuard,
        component: SubscriptionIndex,
        name: 'SubscriptionIndexRoute'
    },
    {
        path: '/subscription/successful',
        beforeEnter: CheckExpertGuard,
        component: SuccessIndex,
        name: 'SuccessIndex'
    },
    {
        path: '/phone/change/successful',
        beforeEnter: CheckExpertGuard,
        component: PhoneSuccessIndex,
        name: 'PhoneSuccessIndex'
    }
]